import tw from 'tailwind-styled-components'

export const UsersContainer = tw.div`
px-8
py-10
`

export const CreateButton = tw.button`
font-semibold
text-sm
text-white
bg-blueTheme
p-2
rounded-lg
h-[38px]
px-6
hover:brightness-95
transition-all
active:scale-95
w-[263px]
`

export const UsersFilters = tw.div`
flex
flex-col
mb-8
`

export const FilterText = tw.span`
text-[11px]
font-semibold
text-darkGray
`

export const FilterButton = tw.button`
h-[38px]
w-[89px]
inline-flex
items-center
justify-center
border
rounded-lg
border-blueTheme
text-blueTheme
text-sm
cursor-pointer
active:scale-95
transition-colors
hover:brightness-90
`

export const FilterContainer = tw.form`
flex 
justify-between
gap-[61px]
`

export const FooterContainer = tw.footer`
flex
items-center
justify-between
`

export const FooterText = tw.span`
text-sm
font-light
text-darkGray/70
`

export const LineUser = tw.div`
h-px
bg-borderLine
mb-6`

export const Title = tw.p`
font-semibold
text-lg
text-blueTheme
`

export const Subtitle = tw.p`
text-sm
text-darkGray/60
mb-6
`

export const CleanFilters = tw.span`
text-xs
font-medium
text-blueTheme
underline
mt-2
cursor-pointer
hover:brightness-75
w-24
`